import { Injectable, Renderer2, RendererFactory2 } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpEvent, HttpResponse, HttpHandler } from "@angular/common/http";
import { NgxSpinnerService } from "ngx-spinner";
import { Observable } from "rxjs";
import { tap } from "rxjs/operators";
import { Time } from '@angular/common';

const bodyScrollClass: string = "loaderBodyScrollFix";
@Injectable({
    providedIn: 'root'
})
export class SpinnerInterceptor implements HttpInterceptor {
    private renderer: Renderer2;
    counter = 0;
    constructor(private spinner: NgxSpinnerService, private rendererFactory: RendererFactory2) {
        this.renderer = rendererFactory.createRenderer(null, null);
    }
    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const start = performance.now();
        this.counter++;
        console.log("counter: " + this.counter + " for req " + req.url);
        this.showLoader();

        return next.handle(req).pipe(tap(async (event: HttpEvent<any>) => {
            console.log(req.url)

            if (event instanceof HttpResponse) {
                //console.log("counter: " + this.counter + " for response " + event.url);

                this.counter--;
                if (this.counter == 0) {
                    this.onEnd();
                }
            }
        },
            (err: any) => {
                //console.log("counter: " + this.counter + " for error API " + err);

                this.counter--;
                if (this.counter == 0) {
                    this.onEnd();
                }
            }));
    }
    private onEnd(): void {
        this.hideLoader();
    }
    private showLoader(): void {
        this.spinner.show();
    }
    private hideLoader(): void {
        this.spinner.hide();
    }
}